import React, { useState, useEffect } from 'react';
import { 
  MicrophoneIcon, 
  StopIcon,
} from '@heroicons/react/24/outline';
import { voiceService } from '../../services/voiceService';

interface VoiceButtonProps {
  onVoiceResult: (text: string) => void;
  onVoiceError: (error: string) => void;
  disabled?: boolean;
  idleClassName?: string;
}

export const VoiceButton: React.FC<VoiceButtonProps> = ({
  onVoiceResult,
  onVoiceError,
  disabled = false,
  idleClassName = 'text-gray-600 hover:text-blue-600 hover:bg-blue-50',
}) => {
  const [isRecording, setIsRecording] = useState(false);
  const [isSupported, setIsSupported] = useState(false);

  useEffect(() => {
    setIsSupported(voiceService.isVoiceSupported());
  }, []);

  const handleVoiceToggle = () => {
    if (isRecording)
    {
      voiceService.stopRecording();
      setIsRecording(false);
      return;
    }

    setIsRecording(true);
    voiceService.startRecording(
      (text) => {
        setIsRecording(false);
        onVoiceResult(text);
      },
      (error) => {
        setIsRecording(false);
        onVoiceError(error);
      }
    );
  };

  if (!isSupported)
  {
    return null;
  }

  return (
    <button
      type="button"
      onClick={handleVoiceToggle}
      disabled={disabled || voiceService.isSpeaking()}
      className={`p-2 rounded-lg transition-colors ${
        isRecording
          ? 'bg-red-500 text-white hover:bg-red-600'
          : idleClassName
      } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
      title={isRecording ? 'Parar gravação' : 'Gravar mensagem de voz'}
      aria-label={isRecording ? 'Parar gravação' : 'Gravar mensagem de voz'}
    >
      {isRecording ? (
        <StopIcon className="h-5 w-5 animate-pulse" />
      ) : (
        <MicrophoneIcon className="h-5 w-5" />
      )}
    </button>
  );
}; 